import React, { useEffect, useRef, useState } from 'react';
import useDebounce from  '@/components/hooks/useDebounce';
import TableHeading from  '@/components/elements/plannerSettings/TableHeading';
import { sortByTable } from  '@/interfaces/plannerSettings';
import { IUser, IUserGroup } from  '@/components/elements/plannerSettings/EditCalendar';
import { BuildPath } from  '@/helpers/Paths';
import useHTTP from  '@/components/hooks/useHTTP';
import TableVal from  '@/components/elements/plannerSettings/TableVal';
import { tableOrder } from  '@/helpers/PlannerSettings';
import SimpleBar from 'simplebar-react';
import { debounce } from "lodash"

const PlannerUserGroupSearch = ({group}:{group:IUserGroup|null}) => {

    const [users, setUsers] = useState<IUser[]>([]);
    const [usersOrder, setUsersOrder] = useState<sortByTable>({field:"", order:null, fieldType:null});
    const [userSearchInput, setUserSearchInput] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);

    const scrollEnd = useRef<boolean>(false);
    const nextUsersSkip = useRef<number>(0);

    const userSearchDebounce = useDebounce(userSearchInput, 500);

    const {get} = useHTTP();

    useEffect(() => {

        search(false)

    }, [userSearchDebounce, group])

    useEffect(() => {

        if (usersOrder.order && usersOrder.field){

            console.table(tableOrder(users, usersOrder))

            setUsers(tableOrder(users, usersOrder))
        }

    }, [usersOrder])

    function handleUserSearch(e:React.KeyboardEvent<HTMLInputElement>){
        if(e.key === "Enter"){
            search(false)
        }
    }

    function search(append:boolean){

        // If not append its a new search so no skip
  
        if (!group?.id) return 

        const query = `${userSearchInput ? `&searchterm=${userSearchInput}` : ''}`

        setLoading(true);

        get(`search/org/group/${group.id}/members?top=20&skip=${append ? nextUsersSkip.current : 0}${query}`).then(({data}) => {

            nextUsersSkip.current = data.nextSkip;

            if (data.users.length < 20){
                scrollEnd.current = true
            }

            if (append){
                setUsers(x => [...x, ...data.users])
            }
            else{
                setUsers(data.users)
            }
            
        }).finally(() => {

            setLoading(false)
        })
    }

    function closeSearch(){

        setUserSearchInput("")

        search(false)
    }

    function scrollHandler (event) {

        if (scrollEnd.current) return

        event.persist()

        debouncedScroll(event)
    }

    const debouncedScroll =  React.useRef(
        
        debounce((event) => {
    
            const {scrollHeight, scrollTop, clientHeight} = event.target;
            const isBottomReached = (scrollHeight - Math.round(scrollTop) <= clientHeight + 15);
        
            if (isBottomReached) {
                search(true)
            }
        }, 500)

    ).current;
    
    return (
        <div className='planner-settings'>

            <h2>{group.groupName}</h2>
          
            <div className='search-users'>
                <input maxLength={100} onKeyDown={handleUserSearch}  value={userSearchInput} onChange={(e) => setUserSearchInput(e.target.value)} type='text' placeholder='Search by name or department' />
                {userSearchInput &&  <img onClick={closeSearch} className="close-results" src={`${BuildPath()}/images/buttons/x-icon.svg`} alt="Close" />}
            </div>

            <div className='users-list-groups'>

                {loading && 
                    <img className="spinner loading" src={`${BuildPath()}/images/spinner.gif`} alt="loading..." />
                }

                <SimpleBar scrollableNodeProps={{onScroll: (e) => scrollHandler(e)}} style={{ maxHeight: 440 }}>

                    <table className="listing-table users-table" cellPadding="0" cellSpacing="0" style={{ maxHeight: 435 }}>

                        <thead>
                            <tr className='heading'>           
                                <TableHeading order={usersOrder} setOrder={setUsersOrder} field="name" label="Username" />
                                <TableHeading order={usersOrder} setOrder={setUsersOrder} field="firstName" label="First Name" />
                                <TableHeading order={usersOrder} setOrder={setUsersOrder} field="lastName" label="Last Name" />
                                <TableHeading order={usersOrder} setOrder={setUsersOrder} field="jobRole" label="Department" />
                            </tr>
                        </thead>

                        <tbody>     
                            {users.map((item, index) => {
                                return (
                                    <tr key={index}>

                                        <td>
                                            <TableVal text={item.name} />                                              
                                        </td>

                                        <td>
                                            <TableVal text={item.firstName} /> 
                                        </td>

                                        <td>
                                            <TableVal text={item.lastName} /> 
                                        </td>

                                        <td>
                                            <TableVal text={item.jobRole} /> 
                                        </td>

                                    </tr>
                                )
                            })}           

                            {users.length === 0 && 
                                <tr>
                                    <td colSpan={4} className="listing-table-empty">No users available</td>
                                </tr>
                            }   
                        </tbody>

                    </table>

                </SimpleBar>

            </div>

        </div>
    );
};

export default PlannerUserGroupSearch;